import { createFileRoute } from "@tanstack/react-router";
import SaintCoralGablesPage from "@/pages/learn/SaintCoralGablesPage";
import { SITE_URL } from "@/components/schemaConstants";

export const Route = createFileRoute("/locations/saint-tms-coral-gables")({
  head: () => ({
    meta: [
      {
        title: "SAINT® TMS Near Coral Gables | Neuro Wellness TMS",
      },
      {
        name: "description",
        content:
          "Looking for SAINT® TMS near Coral Gables & South Miami-Dade? Neuro Wellness in Coral Springs offers the FDA-cleared 5-day SAINT® protocol. See drive times.",
      },
      {
        property: "og:title",
        content: "SAINT® TMS Near Coral Gables | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Looking for SAINT® TMS near Coral Gables & South Miami-Dade? Neuro Wellness in Coral Springs offers the FDA-cleared 5-day SAINT® protocol. See drive times.",
      },
      {
        property: "og:url",
        content: `${SITE_URL}/locations/saint-tms-coral-gables`,
      },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      {
        rel: "canonical",
        href: `${SITE_URL}/locations/saint-tms-coral-gables`,
      },
    ],
  }),
  component: SaintCoralGablesPage,
});
